import introspection from "./introspection.generated";
import type { StrictTypedTypePolicies } from "./clientHelpers.generated";

export const typePolicies: StrictTypedTypePolicies = {
  InterviewerPersonaDefaults: {
    keyFields: false,
  },
  StudyDefaults: {
    keyFields: false,
  },
  StudyStartLink: {
    keyFields: ["url"],
  },
};

export const { possibleTypes } = introspection;
